import React from "react";
import {
  Image,
  ImageBackground,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import style from "./style";
import globalstyle from "../../Styles/Globals/globals";
import ReactMarkdown from "react-markdown";
import {
  getMultimedia,
  getRecursText,
  getRecursURL,
} from "../../Functions/getRecurs";

function PopUpMapaHistoria(RouterData, poi, modalHistoria, setModalHistoria) {
  const { recursos, currentItinerari, idioma } = RouterData.route.params;

  const jocNavigate = () => {
    //todo ajuntar amb la funcio de pois
    setModalHistoria(false);
    currentItinerari.pois.find((e) => e.id == poi.id).popUpLoaded = true;
    currentItinerari.comencat = true;
    switch (poi.Tipus) {
      case "Joc360":
        RouterData.navigation.navigate("CheckIn", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "Info":
        RouterData.navigation.navigate("CheckIn", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "Checkin":
        RouterData.navigation.navigate("CheckIn", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "Quizz":
        RouterData.navigation.navigate("Quizz", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "QuizzImatges":
        RouterData.navigation.navigate("Quizz", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "QuizzLabel":
        RouterData.navigation.navigate("QuizzLabel", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "DragAndDrop":
        RouterData.navigation.navigate("DragAndDrop", {
          ...RouterData.route.params,
          poi,
        });
        break;
      case "Puzzle":
        RouterData.navigation.navigate("Puzzle", {
          ...RouterData.route.params,
          poi,
        });
        break;
      default:
        console.warn("Error joc not found");
        break;
    }
  };

  return (
      <Modal animationType="fade" transparent={true} visible={modalHistoria}>
        <View style={style.modalOutBackground}>
          <View style={[style.caixaPopUp, { height: "80%" }]}>
            <ImageBackground
                source={{
                  uri: getRecursURL(recursos, "background_default", idioma),
                }}
                style={style.backgroundImatges}
            >
              {/* Close button */}
              <TouchableOpacity
                  style={globalstyle.crossBox}
                  onPress={() => setModalHistoria(false)}
              >
                <Image
                    source={{
                      uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
                    }}
                    style={style.cross}
                />
              </TouchableOpacity>

              {/* Header */}
              <View
                  style={{
                    flex: 20,
                    alignItems: "center",
                    width: "90%",
                    justifyContent: "center",
                    alignSelf: "center",
                  }}
              >
                <Text style={[style.popUpTitleInicial]}>
                  {" "}
                  {poi[`Nom${idioma}`]}
                </Text>
              </View>

              {/* Body */}
              {(poi.imatgeHistoria || poi.urlHistoria) ? (
                  <View style={{ flex: 60 }}>
                    <View style={{flex: 30}}>
                      {poi.imatgeHistoria && <Image
                          source={{uri: getMultimedia(poi, "imatgeHistoria")}}
                          style={style.popUpMapaImatge}
                      />}

                      {poi.urlHistoria &&  <iframe
                          src={poi.urlHistoria}
                          allow="fullscreen;geolocation;camera;gyroscope;accelerometer;magnetometer"
                          style={{
                            height: "100%",
                            width: "100%",
                            resizeMode: "contain",
                            borderRadius: 5,
                          }}
                      /> }
                    </View>
                    <View
                        style={{
                          flex: 30,
                          alignItems: "center",
                          alignSelf: "center",
                        }}
                    >
                      <ScrollView
                          style={[
                            style.descriptionContainerHistoria,
                            { alignSelf: "center" },
                          ]}
                      >
                        <ReactMarkdown>
                          {poi[`textHistoria${idioma}`]}
                        </ReactMarkdown>
                      </ScrollView>
                    </View>
                  </View>
              ) : (
                  <View
                      style={{ flex: 60, alignItems: "center", alignSelf: "center" }}
                  >
                    <ScrollView
                        style={[style.popUpMapaText, { alignSelf: "center" }]}
                    >
                      <ReactMarkdown>{poi[`textHistoria${idioma}`]}</ReactMarkdown>
                    </ScrollView>
                  </View>
              )}

              {/* Footer */}
              <View
                  style={{
                    flex: 20,
                    alignItems: "center",
                    alignSelf: "center",
                    justifyContent: "center",
                  }}
              >
                <TouchableOpacity
                    onPress={() => {
                      jocNavigate();
                    }}
                >
                  <Text style={globalstyle.botoContinuar}>
                    {getRecursText(recursos, "poi_iniciar", idioma)}
                  </Text>
                </TouchableOpacity>
              </View>
            </ImageBackground>
          </View>
        </View>
      </Modal>
  );
}

export default PopUpMapaHistoria;
